import { Button } from "@faire/web/slate/Button";
import React, { type JSX } from "react";

import { EmbeddedLink, EmbeddedLinkProps } from "../../ui/EmbeddedLink";
import { Medium } from "../../ui/Typography/Span";

/**
 * @deprecated use InlineLinkFormatting instead
 */
export const LinkFormatting = (
  linkTo: string,
  options?: Partial<EmbeddedLinkProps>
) =>
  function (chunks: JSX.Element) {
    return (
      <EmbeddedLink linkTo={linkTo} {...options}>
        {chunks}
      </EmbeddedLink>
    );
  };

export const ClickableFormatting = (
  onClick: () => void,
  options?: Partial<EmbeddedLinkProps>
) =>
  function (chunks: JSX.Element) {
    return (
      <EmbeddedLink onClick={onClick} {...options}>
        {chunks}
      </EmbeddedLink>
    );
  };

export const MediumFormatting = (chunks: JSX.Element) => (
  <Medium>{chunks}</Medium>
);

export const InlineLinkFormatting = ({
  linkTo,
  textColour,
  onClick,
}: {
  linkTo: string;
  textColour?: string;
  onClick?: () => void;
}) =>
  function (chunk: JSX.Element) {
    return (
      <Button
        style={{ display: "inline" }}
        tertiaryColor={textColour}
        variant="tertiary"
        linkTo={linkTo}
        onClick={onClick}
      >
        {chunk}
      </Button>
    );
  };
